"use client";

import { StediEligibilityActions, StediEligibilityCard } from "@/src/components/tasks/stedi-eligibility-summary";
import { useUser } from "@/src/context/user-context";
import { useToast } from "@/src/hooks/use-toast";
import {
  useRecheckReferralEligibility,
  useStediEligibilityCheck,
} from "@/src/lib/data-fetchers/stedi-eligibility-check-fetchers";
import { canWriteTasks } from "@/src/lib/rbac";

interface ReferralEligibilityCardProps {
  referralId: string;
  taskId: string;
}

export function ReferralEligibilityCard({ referralId, taskId }: ReferralEligibilityCardProps) {
  const { roles } = useUser();
  const { toast } = useToast();
  const { eligibilityCheck, isLoading } = useStediEligibilityCheck(referralId);
  const recheckMutation = useRecheckReferralEligibility(taskId, referralId);

  const handleRecheck = () => {
    recheckMutation.mutate(undefined, {
      onSuccess: (data) => {
        if (data.skipped) {
          toast({
            title: "Eligibility check skipped",
            description: data.reason
              ? `Reason: ${data.reason.replaceAll("_", " ")}`
              : "No matching eligibility details found for this referral.",
            variant: "destructive",
          });

          return;
        }

        toast({
          title: "Eligibility check successful",
          description: "Insurance eligibility check was refreshed.",
        });
      },
      onError: (error) => {
        toast({
          title: "Eligibility check failed",
          description: error instanceof Error ? error.message : "An unexpected error occurred.",
          variant: "destructive",
        });
      },
    });
  };

  return (
    <StediEligibilityCard
      check={eligibilityCheck}
      actions={
        canWriteTasks(roles) && !isLoading ? (
          <StediEligibilityActions
            check={eligibilityCheck}
            onRecheck={handleRecheck}
            isRechecking={recheckMutation.isPending}
          />
        ) : undefined
      }
    />
  );
}
